'use client';
import React from 'react';
import { notFound } from 'next/navigation';
import Hero from './hero';
import MainData from '@/app/data/MainState';
import Backforward from '../backforward';
import Twako from '../../componenets/tawko2';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page({ params }) {
  console.log(MainData, params.BlogsPage, 'blogpage');
  const mapping = MainData?.find((p) => p?.link === params.BlogsPage);

  if (!mapping) {
    notFound(); // Ye Next.js ko 404 page dikhaane ke liye bolta hai
  }
  return (
    <div>
      <title>
        {mapping?.data?.length > 0
          ? mapping.data[1].metaTitle
          : 'Prestige Ride | First-Class Black Car & Chauffeur Services'}
      </title>
      <meta
        name="description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[1].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />

      {/* OG Tags */}
      <meta
        property="og:url"
        content={
          mapping?.data?.length > 0
            ? mapping.data[1].Link
            : 'https://www.prestigeride.com'
        }
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content={
          mapping?.data?.length > 0
            ? mapping.data[1].metaTitle
            : 'About Prestige Ride | Premium Black Car Service'
        }
      />
      <meta
        property="og:description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[1].metaDescription
            : 'From airport transfers and off-site events to city to city rides, book your professional chauffeurs and make your travel experience exceptional.'
        }
      />
      <meta
        property="og:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      {/* Twitter Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="prestigeride.com" />
      <meta
        property="twitter:url"
        content={
          mapping?.data?.length > 0
            ? mapping.data[1].Link
            : 'https://www.prestigeride.com/about'
        }
      />
      <meta
        name="twitter:title"
        content={
          mapping?.data?.length > 0
            ? mapping.data[1].metaTitle
            : 'About Prestige Ride | Premium Black Car Service'
        }
      />
      <meta
        name="twitter:description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[1].metaDescription
            : 'From airport transfers and off-site events to city to city rides, book your professional chauffeurs and make your travel experience exceptional.'
        }
      />
      <meta
        name="twitter:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      <meta name="robots" content="index, follow" />
      <meta
        name="keywords"
        content={mapping?.data?.length > 0 ? mapping.data[1].metaKeywords : ''}
      />
      <link
        rel="canonical"
        href={mapping?.data?.length > 0 ? mapping.data[1].Link : ''}
      />
      <Navbar />
      <Hero Mydata={mapping?.data} />
      <Backforward />
      <Twako />
      <Footer />
    </div>
  );
}

export default page;
